import React, { Component, Fragment } from "react";
import { Modal, ModalBody, Button, ModalHeader } from "reactstrap";
import AdminCursoForm from "./AdminCursoForm"

class AdminCursoModal extends Component {

    state = {
        modal: false
    };

    toggle = () => {
        this.setState(previous => ({
            modal: !previous.modal
        }));
    };  

    render() {
        const create = this.props.create;
        const proyectoCode = this.props.proyectoCodeSelected;
        const proyectoName = this.props.proyectoNameSelected;
        const proyectoMoneda = this.props.proyectoMoneda || 'USD';
        const admin = this.props.admin;
        const partners = this.props.partners;
        const ingresoProyecto = this.props.ingresoProyecto;

        var title = "Editando Administrador del Curso";
        var button = <Button onClick={this.toggle}>
            Editar
        </Button>;

        if (create) {
            title = "Agregando Administrador del Curso";

            button = (
                <Button
                    color="primary"
                    className="float-end"
                    onClick={this.toggle}
                    style={{ minWidth: "200px" }}
                >
                    Agregar Administrador de Curso
                </Button>
            );
        }

        return (
            <Fragment>
                {button}
                <Modal isOpen={this.state.modal} toggle={this.toggle} unmountOnClose>
                    <ModalHeader toggle={this.toggle}>{title}</ModalHeader>
                    <ModalBody>
                        <AdminCursoForm
                            resetState={this.props.resetState}
                            toggle={this.toggle}
                            proyectoCode={proyectoCode}
                            proyectoName={proyectoName}
                            proyectoMoneda={proyectoMoneda}
                            partners={partners}
                            ingresoProyecto={ingresoProyecto}
                            admin={admin}
                        />
                    </ModalBody>
                </Modal>
            </Fragment>
        );
    }
}

export default AdminCursoModal;